import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { EditMetricCrubs } from 'practice/constants/metric-crubs';
import FormMetric, { FormMetricVM } from 'practice/components/metric/form';
import { HttpResponse } from 'shell/models/http-response';
import { MetricData } from 'shell/models/type-metric';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { AxiosPromise } from 'axios';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { metricResponseTransformer } from 'practice/utils/metric-response-transformer';

const EditMetric = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-metrica');
  });

  const params = useParams();

  const [metric] = useHttpFetch<HttpResponse<MetricData>, FormMetricVM>(
    `${__PRACTICE_API_URL__}/pratiche/metrica/${params?.tyRegistro}-${params?.tyPratica}-${params?.tyOperazione}-${params?.codStatoPratica}/${params?.dataAttivazione}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: metricResponseTransformer,
    }
  );

  const updateMetric = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/metrica/`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormMetricVM) => {
      const dataUpdate = updateMetric({
        data: {
          dataDisattivazione: values.validityTo?.toFormat('yyyy-MM-dd') || undefined,
          numMaxOreOperazione: values.hoursMax || null,
          numOrePerWarning: values.hoursWarning || null,
          key: {
            tipoRegistro: values.register || undefined,
            tipoPratica: values.practice || undefined,
            tipoOperazione: values.operation || undefined,
            codStatoPratica: values.state || undefined,
            dataAttivazione: values.validityFrom?.toFormat('yyyy-MM-dd') || undefined,
          },
        },
      }) as AxiosPromise;
      dataUpdate.then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-metrica');
      });
    },
    [updateMetric, navigate]
  );
  return (
    <Fragment>
      <Breadcrumbs items={EditMetricCrubs} />
      {metric.isLoading || metric.pristine || metric.hasErrors ? undefined : (
        <FormMetric
          title="Modifica Metrica"
          onCancel={onCancel}
          isEdit
          onSubmit={onSubmit}
          initialValues={metric?.data as FormMetricVM}
        />
      )}
    </Fragment>
  );
};

EditMetric.displayName = 'New Metric Page component';

export default EditMetric;
